export enum UserStatuses {
    Invited = 1,
    Active = 2,
    Inactive = 3,
}

export enum UserAccessMode {
    Web = 'web',
    App = 'app',
    Both = 'both',
    None = 'none',
}

// TODO: need to add roles & permissions to user model
export interface User {
    id: number;
    identifier: string;
    name: string;
    email: string;
    password: string;
    marketing_consent: boolean | null;
    marketing_consent_given_at: string | null;
    marketing_consent_updated_at: string | null;
    type?: UserType;
    status?: GenericRelation;
    assignment_key?: string;
    assignment_source?: string;
    assignment_tenant_id?: string;
    assignment_tenant_name?: string;
    type_id: number;
    tenants: Tenant[];
    access_mode: UserAccessMode;
    has_surveyor_licence?: boolean;
    can_access_web?: number | boolean;
    is_developer?: boolean;
    roles: any[];
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    signature_available?: boolean;
    signature?: UserSignature | null;
}

export interface UserSignature {
    id: string;
    available: boolean;
    file_name: string;
    mime_type: string;
    size: number;
    width: number;
    height: number;
    checksum: string;
    kind: 'uploaded' | 'drawn';
    preview_url: string | null;
    preview_expires_at: string | null;
    created_at: string;
}

export interface RelatedUser {
    id: number;
    name: string;
    email: string;
    type: GenericRelation;
    status: GenericRelation;
    assignment_key?: string;
    assignment_source?: string;
    assignment_tenant_id?: string;
    assignment_tenant_name?: string;
}

export interface UserType {
    id: number;
    title: string;
}

export interface GenericRelation {
    id: number;
    title: string;
}

export interface UserGeneric {
    id: number;
    value: string;
}

export interface AssigneeUser {
    id: number;
    name: string;
    type_id?: number | null;
    type?: UserType | GenericRelation | null;
    email?: string | null;
    assignment_key?: string;
    assignment_source?: string;
    assignment_tenant_id?: string;
    assignment_tenant_name?: string;
}

export interface UserLookup {
    id: number;
    value: string;
}

export interface Tenant {
    id: string;
    name: string;
    email: string;
    status: string;
    settings?: Array<{
        feature: string;
        name: string;
        payload?: unknown;
        value?: unknown;
    }>;
    billing_address: any;
    trading_address: any;
    early_adopter?: boolean;
    grandfathering_active?: boolean;
    grandfathering_status?: string;
    grandfathering_ends_at?: string | null;
    billing_plan?: string | null;
}
